import { useEffect, useState } from "react";
import Vector from "../assets/Vector.svg";
import _, { template } from "lodash";
import { InputCheckboxGroup } from "../../../Forms/Fields/types/_FormCheckboxGroup";
import ContentResultManual from "./ContentResultManual";
import ContentSlider2Manual from "./ContentSlider2Manual/ContentSlider2Manual.js";
import { v4 as uuidv4 } from "uuid";
import { InputCheckboxSingle } from "../../../Forms/Fields/types/_FormSingleCheckbox";

const ContentTab = ({ form, selectedTemplate, templateData, manualEntries, setManualEntries, setTemplateData, presetBgColor, presetGkColor, effects }) => {
  const [activeSubTab, setActiveSubTab] = useState("Lineup");
  const fields = _.get(templateData, "data.fields", []);
  const [filteredField, setFilteredFields] = useState(fields?.find(
    (item) => item?.type === "checkbox-group" && item?.label === activeSubTab,
  ))

  const [heatmapField, setHeatmapFields] = useState(fields?.find(
    (item) => item?.type === "checkbox-single"
  ))

  useEffect(() => {
    const _originalFields = fields?.find(
      (item) => item?.type === "checkbox-group" && item?.label === activeSubTab,
    );
    if (manualEntries && manualEntries?.length > 0) {
      const updatedField = _.cloneDeep(_originalFields);
      const prevData = _.get(updatedField, 'data', []);
      // Only show manual entries that belong to the active tab, so a
      // Lineup manual player doesn't also show up as a pickable option
      // under Reserve (and vice versa).
      prevData.push(...manualEntries.filter((entry) => entry?.position === activeSubTab));
      setFilteredFields(updatedField);
      // 
      // settemplatedata
    } else {
      setFilteredFields(_originalFields)
    }
  }, [fields, activeSubTab, manualEntries])

  const templateName = selectedTemplate?.template_name;


  // for line up
  const [playerNo, setPlayerNo] = useState(null);
  const [playerName, setPlayerName] = useState(null);

  const onNoChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setPlayerNo(value);
  }

  const onNameChange = (e) => {
    const value = e.target.value;
    setPlayerName(value)
  }

  const onAddNewPlayer = () => {
    if (!playerNo || !playerName) return;

    // filteredField.data holds every currently pickable player for this tab
    // (real squad players + already-added manual entries), so this catches
    // both "editing a manual entry" and "editing a real squad player" by
    // shirt number.
    const existingOption = filteredField?.data?.find(
      (entry) => entry && Number(entry.shirtNumber) === Number(playerNo),
    );

    // Start from the existing player's own fields (jersey redPos/blackPos/
    // whitePos + *Len, arabicName, etc.) so an edit that only touches name/
    // number doesn't wipe out everything else. Reuse its id too — the
    // jersey image URL is built from the player id, so keeping it is what
    // makes an edited *real* squad player keep its jersey photo.
    const newItem = {
      ...existingOption,
      shirtNumber: playerNo,
      shortLastName: playerName,
      id: existingOption ? existingOption.id : uuidv4(),
      position: activeSubTab,
      type: "manualPlayer",
    };

    // Upsert by shirt number/tab instead of always pushing, otherwise
    // re-adding the same number creates a second manual entry. Since
    // newItem reuses existingOption's id, it also naturally replaces (not
    // duplicates) the original in the rendered lineup once merged with the
    // squad data by id, and stays checked/visible without touching the
    // checkbox field's selected-ids at all.
    const withoutOld = manualEntries
      ?.filter((entry) => entry !== null)
      .filter((entry) => !(entry.shirtNumber === playerNo && entry.position === activeSubTab));
    setManualEntries([...withoutOld, newItem]);
  }


  return (
    <div>
      {selectedTemplate && templateName === "fcb_lineup" && (
        <div className="content-tab lineup-content">
          <div className="tab-switcher">
            <button
              type="button"
              className={`tab ${activeSubTab === "Lineup" ? "active" : ""}`}
              onClick={() => setActiveSubTab("Lineup")}
            >
              Lineup
            </button>
            <button
              type="button"
              className={`tab ${activeSubTab === "Reserve" ? "active" : ""}`}
              onClick={() => setActiveSubTab("Reserve")}
            >
              Substitute
            </button>
          </div>

          <div className="add-player-form">
            <input
              type="text"
              placeholder="No."
              className="small-input"
              onChange={onNoChange}
            />
            <input
              type="text"
              placeholder="Player name"
              className="player-input"
              onChange={onNameChange}
            />
            <button type="button" className="add-btn" onClick={onAddNewPlayer}>
              Add
            </button>
          </div>



          {/* Player list */}
          <div className="player-list-box">
            {filteredField?.id ?
              <InputCheckboxGroup
                key={filteredField?.id}
                item={filteredField}
                form={form}
                isCutoutModal={true}
                presetBgColor={presetBgColor}
                setFilteredFields={setFilteredFields}
                setTemplateData={setTemplateData}
                templateData={templateData}
                presetGkColor={presetGkColor}
                includeSmiling={effects?.includeSmiling}
              />
              : (
                <p className="empty-text">No player found</p>
              )}
          </div>
        </div>
      )}
      {(selectedTemplate === "fcb_results" || selectedTemplate === "womens_results" || selectedTemplate === "juniors_results") && (
        <ContentResultManual templateData={templateData} manualEntries={manualEntries} setManualEntries={setManualEntries} isPenalty={effects?.isPenalty} />
      )}
      {selectedTemplate === "fcb_matchday_slider_2" && (
        <ContentSlider2Manual templateData={templateData} manualEntries={manualEntries} setManualEntries={setManualEntries} />
      )}
      {selectedTemplate === "fcb_heatmap" &&
        <InputCheckboxSingle
          key={heatmapField?.id}
          item={heatmapField}
          form={form}
          isCutoutModal={true}
          setFilteredFields={setHeatmapFields}
          setTemplateData={setTemplateData}
          templateData={templateData}
        />
      }
      {!selectedTemplate && (
        <div className="section content-container">
          <img src={Vector} />
          <p className="empty-text">Select a template to begin editing.</p>
        </div>
      )}
    </div>
  );
};

export default ContentTab;
